var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        { "text-justify": _vm.justify },
        { "single-line": _vm.singleLine },
        {
          "w-100 d-flex align-items-center justify-content-between":
            _vm.spaceBetween,
        },
        {
          "d-flex align-items-center flex-wrap":
            !_vm.justify && !_vm.spaceBetween,
        },
      ],
    },
    [
      _vm.icon
        ? _c("font-awesome-icon", {
            staticClass: "ml-2",
            class: _vm.iconClass,
            attrs: { icon: _vm.icon },
          })
        : _vm._e(),
      _c(
        _vm.component,
        {
          tag: "component",
          staticClass: "ml-1",
          class: [_vm.masterClass, _vm.labelClass],
        },
        [_vm._v(" " + _vm._s(_vm.label) + " : ")]
      ),
      _c(
        _vm.component,
        { tag: "component", class: [_vm.masterClass, _vm.valueClass] },
        [
          _vm.computedValue !== undefined
            ? [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.computedValue !== null ? _vm.computedValue : "-"
                    ) +
                    " "
                ),
              ]
            : _vm._e(),
          _vm._t("value"),
        ],
        2
      ),
      _vm.computedValue !== null && _vm.unit
        ? _c("span", { staticClass: "text-muted mr-1", class: _vm.unitClass }, [
            _vm._v(" " + _vm._s(_vm.unit) + " "),
          ])
        : _vm._e(),
      _vm._t("append"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }